import React from 'react';
import EnvolvementThumbnail from "../appComponents/explorePage/EnvolvementThumbnail";

const sampleEnvolvement = {
    _id: "3",
    title: "Art Workshop",
    imgUrl: "https://picsum.photos/seed/picsum/800/602",
    username: "Bob Ross",
    userPicture: "https://i.pravatar.cc/150?img=3",
    price: { price: 0, free: true },
    categories: ["Art", "Workshop"],
    previewText:
      "Unleash your inner artist and paint along with happy little trees.",
    endDate: { endDate: new Date(Date.now() + 20 * 24 * 60 * 60 * 1000).toISOString(), none: false },
    quantity: { unlimited: true, quantity: 0, currentEnvolves: 0 },
    datePublished: "2024-07-10T12:00:00.000Z",
    description: "Unleash your inner artist and paint along with happy little trees.",
};

const timelineItems = [
    {
        title: 'Set up your page',
        description: 'Create a personalized page that represents you and your brand.'
    },
    {
        title: 'Create an Envolvement',
        description: 'Design unique and interactive opportunities for your audience.'
    },
    {
        title: 'Start earning revenue',
        description: 'Monetize your content and passion while building a stronger community.'
    }
];

function Checklist() {
  return (
    <section className="py-20 bg-white text-gray-800">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-20">
          {/* Timeline Section */}
          <div className="lg:w-1/2 max-w-lg">
            <div className="text-left mb-12">
              <h2 className="text-base font-semibold leading-7 text-primary-600">Get Started</h2>
              <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Involve your audience in 3 simple steps
              </p>
            </div>
            <div className="relative">
              {/* Timeline Line */}
              <div className="absolute left-2.5 top-2 bottom-2 w-0.5 bg-gray-200" />
              
              {timelineItems.map((item, index) => (
                <div key={item.title} className="relative pl-10 mb-10">
                  <div className="absolute left-0 top-0 flex items-center justify-center w-6 h-6 bg-primary-600 rounded-full">
                    <span className="text-white text-sm font-bold">{index + 1}</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">{item.title}</h3>
                  <p className="mt-1 text-gray-600">{item.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Envolvement Card Section */}
          <div className="lg:w-1/2 flex justify-center">
            <div className="w-full max-w-sm">
                <EnvolvementThumbnail data={sampleEnvolvement} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Checklist;
